export class UserMedia {
    private static _originalGetUserMedia: ((constraints: MediaStreamConstraints) => Promise<MediaStream>) | null = null
    public static latestVideoMediaStream: MediaStream | null = null
    private static _allMediaStreams: MediaStream[] = []
    private static _isOverridden = false

	public static closeAllMediaStreams(){
		UserMedia._allMediaStreams.forEach(stream => {
			try{
				stream.getTracks().forEach(track => {
					track.stop()
				})
			}catch(e){
				console.warn('error closing media stream', e)
			}
		})
		UserMedia._allMediaStreams = []
		// Clear the latest media stream to prevent dangling references
		UserMedia.latestVideoMediaStream = null
	}

	public static overrideGetUserMedia() {
		// Prevent multiple overrides
		if (UserMedia._isOverridden) {
			console.log('getUserMedia already overridden')
			return
		}

		// Check if getUserMedia is available
		if (!navigator.mediaDevices?.getUserMedia) {
			console.warn('not overriding getUserMedia, navigator.mediaDevices.getUserMedia not found')
			return
		}

		console.log('overriding getUserMedia, navigator.getUserMedia found')

		// Store the original getUserMedia method
		UserMedia._originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices)

		// Override the getUserMedia method
		navigator.mediaDevices.getUserMedia = async (constraints: MediaStreamConstraints) => {
			try {
				// Call the original method with proper context
				const stream = await UserMedia._originalGetUserMedia!(constraints)
				
				// Save all streams, not just video streams
				UserMedia._allMediaStreams.push(stream)
				
				// Update latest media stream if it has any tracks
				if (stream.getVideoTracks().length > 0) {
					UserMedia.latestVideoMediaStream = stream
				}
				
				// Return the stream so the application works normally
				return stream
			} catch (error) {
				console.error('getUserMedia error:', error)
				throw error // Re-throw the error to maintain original behavior
			}
		}

		UserMedia._isOverridden = true
	}

	// Method to restore original getUserMedia if needed
	public static restoreGetUserMedia() {
		if (UserMedia._originalGetUserMedia && UserMedia._isOverridden) {
			navigator.mediaDevices.getUserMedia = UserMedia._originalGetUserMedia
			UserMedia._originalGetUserMedia = null
			UserMedia._isOverridden = false
			console.log('getUserMedia restored to original implementation')
		}
	}
}

UserMedia.overrideGetUserMedia()
;(window as any).UserMedia = UserMedia